__turbopack_context__.v({
  "copy": "MissingFullBodyCta-module-scss-module__R2rXyq__copy",
  "cta": "MissingFullBodyCta-module-scss-module__R2rXyq__cta",
  "emphasis": "MissingFullBodyCta-module-scss-module__R2rXyq__emphasis",
  "iconContainer": "MissingFullBodyCta-module-scss-module__R2rXyq__iconContainer",
  "link": "MissingFullBodyCta-module-scss-module__R2rXyq__link",
});
